(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-wrapper.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-wrapper.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createContext,
  useContext,
  useReducer
} = React;

const GameContext = createContext();
const useGameContext = () => {
  const context = useContext(GameContext);
  if (context === undefined) {
    throw new Error('useGameContext must be used within a GameContext.Provider');
  }
  return context;
};
setGlobal('svs.ticketgames.ticketUtility.components.useGameContext', useGameContext);
setGlobal('svs.ticketgames.ticketUtility.components.GameContext', GameContext);
const reducer = (state, action) => {
  switch (action.type) {
    case 'GAME_LAUNCHER_ERROR':
      return _objectSpread(_objectSpread({}, state), {}, {
        launcherError: true
      });
    default:
      return state;
  }
};
setGlobal('svs.ticketgames.ticketUtility.components.GameWrapper', _ref => {
  let {
    children,
    className = '',
    context,
    styles
  } = _ref;
  const [state, launcherDispatch] = useReducer(reducer, {
    launcherError: null
  });
  React.useEffect(() => {
    if (state.launcherError) {
      svs.tur.apierrors.showErrorMessage({
        onConfirm: () => {
          location.href = svs.core.data.baseUrl;
        },
        response: 0
      });
    }
  }, [state.launcherError]);
  if (state.launcherError) {
    return null;
  }
  return React.createElement(GameContext.Provider, {
    value: _objectSpread(_objectSpread({}, context), {}, {
      launcherDispatch
    })
  }, React.createElement("div", {
    className: "".concat(className, " relative overflow-hidden"),
    style: styles
  }, children));
});

 })(window);